import {APP_INITIALIZER, ApplicationConfig, ErrorHandler, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideAuth} from './core/auth/auth.provider';
import {provideNgxMask} from 'ngx-mask';
import {ScriptLoaderService} from './core/services/script-loader.service';
import {ChunkErrorHandler} from './core/error/chunk-error-handler';

export function loadAcceptJs(scriptLoader: ScriptLoaderService) {
    return () => scriptLoader.loadAcceptJs();
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({eventCoalescing: true}),
        provideRouter(routes),
        provideAuth(),
        provideNgxMask({
            validation: false
        }),
        ScriptLoaderService,
        {
            provide: ErrorHandler,
            useClass: ChunkErrorHandler
        },
        {
            provide: APP_INITIALIZER,
            useFactory: loadAcceptJs,
            deps: [ScriptLoaderService],
            multi: true
        }
    ]
};
